// @flow
import * as StorageApiService from '../services/StorageApiService';

export function buildAuthorizationHeader() {
  try {
    const auth = StorageApiService.getAuthData();

    return `${auth.type} ${auth.accessToken}`;
  } catch (err) {
    return null;
  }
}

export default buildAuthorizationHeader;



// WEBPACK FOOTER //
// ./src/modules/auth/helpers/buildAuthorizationHeader.js